/*
  Grilluxe Header — Mobile-Menü, Such-Panel, Sticky-Scroll-Zustand.
  Vanilla JS, keine Library.

  Live Polish: Scroll-Listener togglet nur eine CSS-Klasse (`is-scrolled`) auf
  `.site-header` — die eigentliche Farblogik (transparent+hell -> hell+dunkel)
  steckt komplett in component-header.css. Läuft auf jeder Seite mit, wirkt sich
  aber nur auf der Homepage sichtbar aus (dort ist der Header transparent); auf
  Unterseiten ist er ohnehin immer im hellen/dunklen Solid-Zustand.
*/
(function () {
  var header = document.querySelector(".site-header");
  if (!header) return;

  var SCROLL_THRESHOLD = 40;
  var ticking = false;

  function updateScrollState() {
    var isScrolled = window.scrollY > SCROLL_THRESHOLD;
    header.classList.toggle("is-scrolled", isScrolled);
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateScrollState);
  }

  updateScrollState();
  window.addEventListener("scroll", onScroll, { passive: true });

  var menuToggle = header.querySelector("[data-header-menu-toggle]");
  var menuPanel = document.getElementById("HeaderMobileMenu");
  var searchToggle = header.querySelector("[data-header-search-toggle]");
  var searchPanel = document.getElementById("HeaderSearchBar");

  function closeMenu() {
    if (!menuPanel) return;
    menuPanel.dataset.open = "false";
    menuToggle.setAttribute("aria-expanded", "false");
    document.body.classList.remove("menu-open");
  }

  function openMenu() {
    if (!menuPanel) return;
    menuPanel.dataset.open = "true";
    menuToggle.setAttribute("aria-expanded", "true");
    document.body.classList.add("menu-open");
  }

  if (menuToggle && menuPanel) {
    menuToggle.addEventListener("click", function () {
      var isOpen = menuPanel.dataset.open === "true";
      if (isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && menuPanel.dataset.open === "true") {
        closeMenu();
        menuToggle.focus();
      }
    });

    document.addEventListener("click", function (event) {
      if (menuPanel.dataset.open !== "true") return;
      var target = event.target;
      var isInsideMenu = menuPanel.contains(target);
      var isToggle = menuToggle.contains(target);
      if (!isInsideMenu && !isToggle) {
        closeMenu();
      }
    });
  }

  if (searchToggle && searchPanel) {
    searchToggle.addEventListener("click", function () {
      var isOpen = searchPanel.dataset.open === "true";
      searchPanel.dataset.open = isOpen ? "false" : "true";
      searchToggle.setAttribute("aria-expanded", isOpen ? "false" : "true");
      if (!isOpen) {
        var input = searchPanel.querySelector("input");
        if (input) input.focus();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && searchPanel.dataset.open === "true") {
        searchPanel.dataset.open = "false";
        searchToggle.setAttribute("aria-expanded", "false");
        searchToggle.focus();
      }
    });
  }
})();
